<template>

  <div class="welcomeImage">
      <div class="welcomeImage__hello">Добро пожаловать, кибервнук!</div>
      <img class="welcomeImage__img" src="@/assets/img/shared/welcome.png">
  </div>
</template>
<script>
export default {
  name: "WelcomeImage"
}
</script>

<style scoped lang="scss">
.welcomeImage {
  flex: 1 1 0;
  min-height: 410px;
  border-radius: 20px;
  background: #62C064;
  text-align: right;
  position: relative;
  overflow: hidden;

  @include respond-to('md') { min-height: 410px; }
  @include respond-to('sm') { display: none; }

  &__hello {
    font-size: clamp(22px, 3vw, 36px);
    font-family: var(--cd-bold-font);
    font-weight: 500;
    color: black;
    padding: 34px 0 0 34px;
    text-align: left;
    position: relative;
    z-index: 1;
  }

  &__img {
    position: absolute;
    border-radius: 20px;
    right: 0;
    bottom: 0;
    max-width: 70%;
    height: auto;
  }
}
</style>
